class Dropdown {
  public trigger: NodeListOf<Element>;
  public allowDropdownMenuOnClickEvent = true;
  public breakpoint = 1024;

  constructor() {
    this.trigger = document.querySelectorAll('[data-trigger="dropdown"]');    
    if(this.trigger){
      this._init();
    }
  }
  
  _init() {
    this.checkWindowSize();
    this.listenClickEventToToggleDropdown();
    this.listenWindowResize();
  }

  private listenClickEventToToggleDropdown(){
    this.trigger.forEach(element => {
      
      element.addEventListener('click', (event) => {
        if(this.allowDropdownMenuOnClickEvent){
          // au click sur la div parente
          // on stoppe la propagation de l'évenement click
          // et donc la redirecteion du lien
          event.preventDefault();
          event.stopPropagation();
          
          // code qui permet d'ouvrir et fermer le sous menu
          // ce code est utilise uniquement en responsive 
          // car on écoute l'élément click en responsive
          const parentElement = element?.parentNode as HTMLElement
          parentElement.classList?.toggle('active');

        }
      });
    });
  }

  private listenWindowResize(){
    window.addEventListener("resize", () => {
      this.checkWindowSize()

      if (window.innerWidth > this.breakpoint) {
        this.trigger.forEach(element => {
          element.classList.remove('active');
        });
      }
    });
  }

  private checkWindowSize(){
    if (window.innerWidth > this.breakpoint) {
      this.allowDropdownMenuOnClickEvent = false
    } else {
      this.allowDropdownMenuOnClickEvent = true
    }
  }

}
export let dropdown = new Dropdown();
